"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserStatusEnum = void 0;
var UserStatusEnum;
(function (UserStatusEnum) {
  /** Гость */
  UserStatusEnum[UserStatusEnum["guest"] = 0] = "guest";
  /** Не подтверждённый пользователь */
  UserStatusEnum[UserStatusEnum["not_confirmed"] = 1] = "not_confirmed";
  /** Подтверждённый пользователь */
  UserStatusEnum[UserStatusEnum["confirmed"] = 2] = "confirmed";
  /** Заблокирован администрацией */
  UserStatusEnum[UserStatusEnum["banned"] = 3] = "banned";
  /** Удалён по собственному желанию */
  UserStatusEnum[UserStatusEnum["deleted"] = 4] = "deleted";
  /** Школа (технический статус) */
  UserStatusEnum[UserStatusEnum["school"] = -1] = "school";
})(UserStatusEnum = exports.UserStatusEnum || (exports.UserStatusEnum = {}));
